// function to initiate deep linking
import $ from 'jquery';
import {capitalizeFirstLetter, setWindowLocationHash} from '../libs/common-library';

function initiateDeepLinkForRHS(urlArray)
{
    var addedIndex = 0;
    const minUrlLengthForApiWithoutExamples = 4;
    const minUrlLengthForApiWithExamples = 5;
    const minUrlLengthForApiWithTwoLevelExamples = 6;

    if(urlArray.length == minUrlLengthForApiWithoutExamples){
        var prefix = urlArray[minUrlLengthForApiWithoutExamples-1];
        if(prefix.indexOf("liveconsole-tab") > -1){
            initiateDeepLinkforLiveConsoleTab(prefix);
        }
        else {
            initiateDeepLinkForSampleCode(prefix);
        }
    }
    if(urlArray.length >= minUrlLengthForApiWithExamples)
    {
        var prefix = urlArray[minUrlLengthForApiWithExamples-2];
        var sample_req_id = urlArray[minUrlLengthForApiWithExamples-1];
        if (prefix.indexOf("samplerequests-dropdown") > -1)
     {
        
        $('button[data-test="heading-level-tabs-request-builder-1-cybsTabItem"]').trigger('click');
        $('button[data-test="sample-request-combobox-cybsButton-icon"]').trigger('click');
        setTimeout(function() {
            $('li[id^='+ sample_req_id + ']').trigger('click');
        }, 1);
        var element = document.getElementById(sample_req_id);
        if(element != null)
        {
            element.click();
        }
        if(urlArray.length >= minUrlLengthForApiWithTwoLevelExamples){
            var secondId = urlArray[minUrlLengthForApiWithTwoLevelExamples-1];
            if(!(secondId.indexOf("ruby") > -1 || secondId.indexOf("php") > -1 || secondId.indexOf("c#") > -1 || secondId.indexOf("java") > -1 || secondId.indexOf("python") > -1 || 
            secondId.indexOf("node") > -1 || secondId.indexOf("liveconsole-tab") > -1)){
                setTimeout(function() {
                    $('li[id^='+ secondId + ']').trigger('click');
                }, 1);
                var element = document.getElementById(sample_req_id);
                if(element != null)
                {
                    element.click();
                }
                addedIndex = 1;
            }
        }
     }

    else if(prefix.indexOf("requestfielddescription") > -1 || prefix.indexOf("requestexpandedfielddescription") > -1){
        var prefixArray = [];
        $("span:contains('Descriptions')").parent().closest('button').trigger('click');
        $("button[data-test^='expandButton']").trigger('click');
        initiateDeepLinkForRequestResponseDescription("requestexpanded-",prefixArray,urlArray.slice(4));
    }
    else if(prefix.indexOf("responsefielddescription") > -1){
        var prefixArray = [];
        $("span").filter(function() { return ($(this).text() === 'Descriptions') }).trigger('click');
        initiateDeepLinkForRequestResponseDescription("response-",prefixArray,urlArray.slice(4));
    }
     if(urlArray.length >= minUrlLengthForApiWithTwoLevelExamples)
     {
        var id = urlArray[5+addedIndex];
        initiateDeepLinkForSampleCode(id);

         if(id.indexOf("liveconsole-tab") > -1)
         {
            initiateDeepLinkforLiveConsoleTab(id);
         } 
        }
     }
    // if id contains sample code, navigates to sample code 
}

function initiateDeepLinkForSampleCode(id){
    if(id.indexOf("ruby") > -1 || id.indexOf("php") > -1 || id.indexOf("c#") > -1 || id.indexOf("java") > -1
    || id.indexOf("python") > -1 || id.indexOf("node") > -1)
    {
       $('button[data-test^="switch-language-"]').trigger('click');
       var sampleCodeIdentifier = id.split("-");
       var samplecode_id = sampleCodeIdentifier[sampleCodeIdentifier.length -1].replace("#","-");
       setTimeout(function() {
            $('li[id^='+ samplecode_id + ']').trigger('click');
        }, 1);
       
    }
}

function initiateDeepLinkforLiveConsoleTab(id){
    if(id == "liveconsole-tab-request-body")
    {
        $("span:contains('Body')").parent().closest('button').trigger('click');
    }
    else if(id == "liveconsole-tab-request-headers")
    {
        $("span:contains('Headers')").parent().closest('button').trigger('click');
    }
    else if(id == "liveconsole-tab-request-descriptions")
    {
        $("span:contains('Descriptions')").parent().closest('button').trigger('click');
    }
    else if(id == "liveconsole-tab-request-queryparams")
    {
        $("span:contains('Query Parameters')").parent().closest('button').trigger('click');
    }
}

// recursive function which will go deep by expanding top down 
function initiateDeepLinkForRequestResponseDescription(textPrefix,prefixArray,urlArray)
{
    
    if(urlArray.length == 1)
    {
        var prefixString = "";
        var delimiter = "-";
       
        if(prefixArray.length >= 1)
        {
            for(var element in prefixArray)
            {
                prefixString = prefixString + prefixArray[element] + "-";  
            } 
            if(prefixString.charAt(prefixString.length-1).indexOf ('-') > -1)
            {
                prefixString = prefixString.slice(0,prefixString.length-1);
            }
        }

        if(prefixString != "")
        {
            prefixString = prefixString + delimiter;
        }

        if($('div[id="btn-show-' + textPrefix + prefixString  + urlArray[0] +'"]').length > 0){
            $('div[id="' + textPrefix + prefixString  + urlArray[0] +'"]').trigger('focus');
            $('div[id="btn-show-' + textPrefix + prefixString + urlArray[0] +'"]').trigger('click');
            $('div[id="btn-show-' + textPrefix + prefixString + urlArray[0] +'"]')[0].scrollIntoView(true);
        }
        if( $('span[id="span-show-' + textPrefix + prefixString + urlArray[0] +'"]').length > 0){
            $('span[id="span-show-' + textPrefix + prefixString + urlArray[0] +'"]').trigger('focus');
            $('span[id="span-show-' + textPrefix + prefixString + urlArray[0] +'"]').trigger('click');
            $('span[id="span-show-' + textPrefix + prefixString + urlArray[0] +'"]')[0].scrollIntoView(true);
        }
        var windowUrl = encodeURI(window.location.hash);
        var decodedWindowUrl = decodeURI(windowUrl);
        if(decodedWindowUrl.indexOf("requestexpandedfielddescription") > -1)
        {
            decodedWindowUrl = decodedWindowUrl.replace("requestexpandedfielddescription","requestfielddescription");
            setWindowLocationHash(decodedWindowUrl);
        }
        return ;
       
    }
     
    else
    {       
        // check if the split is greater than 0 
        var prefixString = "";
        if(prefixArray.length >= 1)
        {
            for(var element in prefixArray)
            {
                prefixString = prefixString + prefixArray[element] + "-";  
            } 
            if(prefixString.charAt(prefixString.length-1).indexOf ('-') > -1)
            {
                prefixString = prefixString.slice(0,prefixString.length-1);
            }
        }
        

        var delimiter = "-";
        if(prefixString != "")
        {
            prefixString = prefixString + delimiter;
        }
        $('button[id="' + textPrefix + prefixString + urlArray[0]+'"]').trigger('focus');
        $('div[id="btn-show-' +  textPrefix  + prefixString + urlArray[0]+'"]').trigger('click');
        prefixArray.push(urlArray[0]);
        initiateDeepLinkForRequestResponseDescription(textPrefix,prefixArray,urlArray.slice(1));

            return;
    }
}

export default initiateDeepLinkForRHS;
export {initiateDeepLinkForRHS};